/* tslint:disable */
/* eslint-disable */
/**
 * Notification service API
 * Service for handling and managing notifications
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Message for sending by email
 * @export
 * @interface SentMessage
 */
export interface SentMessage {
    /**
     * Email subject
     * @type {string}
     * @memberof SentMessage
     */
    subject?: string;
    /**
     * Email text
     * @type {string}
     * @memberof SentMessage
     */
    message?: string;
}

/**
 * Check if a given object implements the SentMessage interface.
 */
export function instanceOfSentMessage(value: object): boolean {
    return true;
}

export function SentMessageFromJSON(json: any): SentMessage {
    return SentMessageFromJSONTyped(json, false);
}

export function SentMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SentMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'subject': json['subject'] == null ? undefined : json['subject'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function SentMessageToJSON(value?: SentMessage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'subject': value['subject'],
        'message': value['message'],
    };
}

